import Footer from "@/components/ui/footer";
import SkipLinks from "@/components/ui/skip-links";

/**
 * Layout-Komponente für alle Seiten
 * Stellt das grundlegende Layout mit Header, Content-Bereich und Footer bereit
 * 
 * Diese Komponente definiert die Struktur aller Seiten der Anwendung
 * und sorgt für ein konsistentes Erscheinungsbild
 * 
 * @param {Object} props - Komponenten-Props
 * @param {React.ReactNode} props.children - Zu rendernde Kind-Komponenten (Seiteninhalt)
 * @param {string} props.currentPageName - Name der aktuellen Seite (für Navigation und Tracking)
 * 
 * @example
 * ```jsx
 * <Layout currentPageName="Home">
 *   <HomePage />
 * </Layout>
 * ```
 */
export default function Layout({ children, currentPageName }) {
    return (
        <div className="min-h-screen flex flex-col">
            {/* Skip-Links für bessere Barrierefreiheit */}
            <SkipLinks />
            
            {/* Hauptinhalt der Seite */}
                               <main className="flex-grow" role="main" aria-label="Hauptinhalt">
                {children}
            </main>
            
            {/* Footer mit Kontaktinformationen und Links */}
            <Footer />
        </div>
    )
}
